import type { ChangeEvent } from "react";
import { cn } from "../helpers/class-names";

export type SegmentedControlOption<T extends string> = {
  value: T;
  label: string;
};

export function SegmentedControl<T extends string>({
  className,
  label,
  name,
  options,
  value,
  onValueChange,
}: {
  className?: string;
  label: string;
  name: string;
  options: readonly SegmentedControlOption<T>[];
  value: T;
  onValueChange: (value: T) => void;
}) {
  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    onValueChange(event.target.value as T);
  }

  return (
    <fieldset className={cn("ui-segmented-control", className)}>
      <legend className="ui-visually-hidden">{label}</legend>
      {options.map((option) => (
        <label key={option.value}>
          <input
            checked={value === option.value}
            name={name}
            type="radio"
            value={option.value}
            onChange={handleChange}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </fieldset>
  );
}
